import { render, staticRenderFns } from "./ModalProdutoSelect.vue?vue&type=template&id=610fe8ea&"
import script from "./ModalProdutoSelect.vue?vue&type=script&lang=js&"
export * from "./ModalProdutoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports